import { varGlobal } from "../shared/varGlobal";
import { Injectable } from "@angular/core";
import { AppSettingsService } from "./appsettings.service";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

/**
 *  Service de recuperation de données pour l'administration
 */
@Injectable()
export class AccueilService {
  /** Chemin vers l'API */
  public w_baseUrl: string = "";

  /**
   * Constructeur
   */
  constructor(
    public http: HttpClient,
    public s_appsettings: AppSettingsService,
    public s_global: varGlobal
  ) {
    this.w_baseUrl = this.s_global.pathAPI + "/accueil";
  }

  /**
   *  Recuperation des informations pour les compteurs du panneau d'administration
   */
  public proc_getInformationsCompteurs(w_tiersId: number): Observable<any> {
    return this.http.get(
      `${this.w_baseUrl}/getInfos/` + w_tiersId,
      this.s_appsettings.proc_getHeaders()
    );
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/services/accueil.service.ts